import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function Dialogue({ item, index }) {
  return <QuestionHOC item={item} index={index}>
    <div className="row">
      <div className="col">
        <p className="mt-3" style={{
          fontSize: 18,
          fontWeight: 'bold'
        }}>Additional Dialogue</p>
      </div>
    </div>

    <div className="row">
      <div className="col-6">
        <p><strong>Dr. Trevor Wang:</strong></p>
        <p><strong>Jane Doe:</strong></p>
      </div>
      <div className="col-6">
        <p>How are you feeling today?</p>
        <p>I'm feeling good now.</p>
      </div>
    </div>
  </QuestionHOC>
}